module.exports = {
  text: `Быть не только в плену своих эмоций, но ещё и терпеть физические изменения от этого? Лучше уж вообще не иметь эмоций.`,
  author: `Архимаг Морденкайнен`,
}
